import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function MoneyDetail({ label, value }) {
  if (!value) {
    return null;
  }

  return (
    <Grid
      item
      lg={4}
      xs={12}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="tertiary"
          size="xs"
          uppercase
        >
          {label}
        </Text>
        <Text
          size="xl"
          weight="medium"
        >
          {value}
        </Text>
      </Stack>
    </Grid>
  );
}

MoneyDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};
